import React from 'react';
import placeholder from 'static/img/car-photo.png';

export const PhotosCellRenderer = ({ colDef, data }) => (
  <div
    className="photo-cell-image-wrap"
    onClick={() => colDef.onPhotoClick(data)}
  >
    <div className="photo-cell-image-overlay">
      <i className="fa fa-search-plus" />
    </div>
    <img
      alt={`${data.VehicleBrand} ${data.VehicleModel}`}
      className="photo-cell-image pointer"
      src={
        data.Thumbnails && data.Thumbnails.find(x => x.Order === 1)
          ? data.Thumbnails.find(x => x.Order === 1).Filepath
          : placeholder
      }
    />
  </div>
);

export const PhotosAntCellRenderer = (data, onPhotoClick) => (
  <div
    className="photo-cell-image-wrap"
    onClick={() => onPhotoClick && onPhotoClick(data)}
  >
    <div className="photo-cell-image-overlay">
      <i className="fa fa-search-plus" />
    </div>
    <img
      alt={`${data.VehicleBrand} ${data.VehicleModel}`}
      className="photo-cell-image pointer"
      src={
        data.Thumbnails && data.Thumbnails.find(x => x.Order === 1)
          ? data.Thumbnails.find(x => x.Order === 1).Filepath
          : placeholder
      }
    />
  </div>
);

export const ImageAntCellRenderer = data => (
  <div className="photo-cell-image-wrap">
    <img
      alt={`${data.VehicleBrand} ${data.VehicleModel}`}
      className="img-cell-image pointer"
      src={
        data.Images && data.Images.find(x => x.Order === 1)
          ? data.Images.find(x => x.Order === 1).Filepath
          : placeholder
      }
    />
  </div>
);
